import { useQuery } from "@tanstack/react-query";
import { PatientPortalNotificationControllerApi } from "../../services";
import { getConfigObject, getXtenantId, useBaseContent } from "../../utils/utils";

export const useGetPatientPortalUnreadCounts = (
  patientUuid: string
): useBaseContent<any> =>
  useQuery({
    queryKey: ["patient-portal-unread-counts", patientUuid],
    enabled: !!patientUuid,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      await new PatientPortalNotificationControllerApi(getConfigObject())
        .getUnreadCounts(patientUuid, getXtenantId() ?? undefined)
        .then((res) => res?.data),
  });
